import React, { useEffect, useRef, useState } from "react";
import { ModalClosed, CalendarIcon, LogoVend } from "~misc/icons";
import { money } from "~hooks/useHelpers";
import {  pdf, BlobProvider } from '@react-pdf/renderer';
import "./style.scss";
import { PDFContent } from "./PDFContent";
import usePrazoRegraSimuladores from "~fetchs/usePrazoRegraSimuladores";
import { db } from "~db/db";

const ModalSimulacaoPDF = ({ isOpen, onClose, desconto, simuId = null, simulacaoItem, simulacaoAtualizada, grupos, values, simulacao, calcCif, cliente, calcCifModal, todosOsProdutos, usuario, getTodayDate }) => {
  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]" : "hidden";
  const overlayClasses = isOpen ? "fixed inset-0 bg-black opacity-50 z-40" : "hidden";


  const [modalHeight, setModalHeight] = useState(Math.min(window.innerHeight - 20, 600));
  const familiasIds = (simulacaoItem?.gruposProduto || [])
  .flatMap((grupo) => grupo.produtos || [])
  .map((produto) => produto.produtoOriginal?.familiaId)
  .filter((id) => !!id);
  const { prazoRegras, familiasPrazoDisponiveis } = usePrazoRegraSimuladores({
    gruposegmento: cliente?.grupoSegmentoId,
    familias: familiasIds
  });
  const searchDias = (familiaId, prazoRegras) => {
    const prazoRegra = prazoRegras.find((regra) =>
      regra.familias.some((familia) => familia.id === familiaId)
    );
    return prazoRegra ? `${prazoRegra.dias } dias`: '-';
  };


  const [prazoPagamentos, setPrazoPagamentos] = useState([]);
  useEffect(() => {
    const fetchPrazoPagamentos = async () => {
      const result = await db.prazoPagamento.filter((a) => a.ativo).toArray();
      setPrazoPagamentos(result);
    };

    fetchPrazoPagamentos();
  }, []);


  useEffect(() => {
    function handleResize() {
      setModalHeight(Math.min(window.innerHeight - 20, 600));
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleDownloadPDF = async () => {
    if (!simulacaoAtualizada) return;

    // Gerar blob do PDF
    const blob = await pdf(
      <PDFContent
      prazoPagamentos={prazoPagamentos}
      prazoRegras={prazoRegras}
      searchDias={searchDias}
      grupos={grupos}
      calcCif={calcCif}
      values={values}
      todosOsProdutos={todosOsProdutos}
      cliente={cliente}
      calcCifModal={calcCifModal}
      simulacaoAtualizada={simulacaoAtualizada}
      simulacao={simulacao}
      usuario={usuario}
      // formatNumerFix={formatNumerFix}
      getTodayDate={getTodayDate}
      />
    ).toBlob();

    // Converter para base64
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      console.log('Base64:', base64data);

      // Download automático
      const link = document.createElement('a');
      link.href = base64data;
      link.download = 'simulacao.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  };

  return (
    <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white w-full max-w-[1000px] pb-4 pt-4 rounded-[20px] shadow-lg z-50  relative">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
            >
              <ModalClosed />
            </button>
          </div>

          {/* <button onClick={handleClick}>Baixar</button> */}

          <div>
            <div className="pdf-content">
              <div className="container bg-white p-4 rounded-lg container-1">
                <div className="mb-10 flex justify-between mt-8">
                  <LogoVend />
                  <button
                    className={simulacao !== undefined ? "px-6 py-2 bg-primaria text-white font-bold rounded-md baixarPDF" : "px-6 py-2 bg-primaria text-white font-bold rounded-md baixarPDF opacity-50"}
                    onClick={handleDownloadPDF}
                    disabled={simulacao !== undefined ? false : true}
                  >
                    Baixar PDF
                  </button>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-2xl title__simulators p-3">
                      Simulador: <strong className="font-bold">Ensacados</strong>
                    </h3>
                  </div>
                  <div className="flex gap-x-2 items-center justify-end text-lg">
                    <CalendarIcon />
                    <p>Data: {new Date().toLocaleDateString()}</p>
                  </div>
                </div>
                <div className="max-w-[1216px] mx-auto px-4 pt-12 pb-1">
                  <h4 className="text-lg text-start">
                    Inclui o Valor de Fracionamento:<b> {values?.fracionario ? "Sim" : "Não"}</b>
                  </h4>
                  <h4 className="text-lg text-start">
                    Inclui o Valor de Descarga Manual:<b> {values?.descarga ? "Sim" : "Não"}</b>
                  </h4>
                </div>
                <div className="overflow-x-auto max-h-[400px] listagemPDF">
                  {((simulacao?.gruposProduto && simulacao.gruposProduto.length) ||
                    (simulacao?.gruposMateriais && simulacao.gruposMateriais.length)) > 0 &&
                    grupos.map((item, gruposIndex) => (
                      <>
                        <div className="container mx-auto px-4 pt-4 pb-4  print-page">
                          <h3 className="bg-primaria p-2 text-white text-center font-bold text-lg rounded-t-lg">
                            {item.grupoMaterial}
                          </h3>
                          <div className="">
                            <div className=" max-w-[1216px] mx-auto">
                              <div className=" bg-white rounded-lg overflow-hidden">
                                <div className=" uppercase text-sm text-gray-600 flex  text-center">
                                  <div className="py-3 px-4 flex-1 font-bold text-black bg-gray-200 ">Material</div>
                                  <div className="py-3 px-4 flex-1 font-bold text-black bg-gray-200 ">Centro</div>
                                  <div className="py-3 px-4 flex-1 font-bold text-black bg-gray-200 ">Quantidade</div>
                                  <div className="py-3 px-4 flex-1 font-bold text-black bg-gray-200 ">
                                    Preço Final FOB
                                  </div>
                                  <div className="py-3 px-4 flex-1 font-bold text-black bg-gray-200 ">
                                    Preço Final CIF
                                  </div>
                                  <div className="py-3 px-4 flex-1 font-bold text-black bg-gray-200 ">
                                    Prazo de Pagamento
                                  </div>
                                </div>
                                {item.produtos &&
                                  item.produtos.map((item, index) => {
                                    const pzPagamento = prazoPagamentos?.find((p) => p.id === item.prazoPagamentoId);
                                    return (
                                      <div
                                        key={index}
                                        className={`${index % 2 === 0
                                          ? "flex gap-x-1 text-center  mb-2"
                                          : "flex gap-x-1 text-center  mb-2 bg-[#DDEBF7]"
                                          }`}
                                      >
                                        <div className="py-2 px-4 flex-1  text-black">{item.produto}</div>
                                        <div className="py-2 px-4 flex-1  text-black">{item.filial}</div>
                                        <div className="py-2 px-4 flex-1  text-black">
                                          {item.quantidade || 1}
                                        </div>

                                        <div className="py-2 px-4 flex-1  text-black">
                                          {money((item.precoFinal.fob ?? 0)  + (item?.beneficioFis?.fob || 0))}
                                        </div>
                                        <div className="py-2 px-4 flex-1  text-black">
                                          {calcCifModal(item.precoFinal.cif, item)}
                                        </div>
                                        <div className="py-2 px-4 flex-1  text-black">
                                          {pzPagamento ? pzPagamento?.nome : searchDias(item?.produtoOriginal.familiaId , prazoRegras)}
                                        </div>
                                      </div>
                                    )
                                  }

                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
      <div style={{ display: 'none' }}>
        <BlobProvider document={
          <PDFContent
            prazoPagamentos={prazoPagamentos}
            prazoRegras={prazoRegras}
            searchDias={searchDias}
            grupos={grupos}
            values={values}
            cliente={cliente}
            calcCifModal={calcCifModal}
            calcCif={calcCif}
            simulacaoAtualizada={simulacaoAtualizada}
            todosOsProdutos={todosOsProdutos}
            simulacao={simulacao}
            usuario={usuario}
            // formatNumerFix={formatNumerFix}
            getTodayDate={getTodayDate}
          />
        }>
          {({ url }) => url && <iframe src={url} />}
        </BlobProvider>
      </div>
    </div>
  );
};

export default ModalSimulacaoPDF;
